import React from 'react';
import styled from 'styled-components';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const GaugeStyle = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	background: #edefef;
	display: flex;
	align-items: center;
	justify-content: center;
	.gauge-wrapper {
		width: ${props => props.width};
		height: ${props => props.height};
		position: relative;
		.CircularProgressbar {
			fill: #edefef;
		}
		.CircularProgressbar-trail {
			stroke-width: 1;
		}
		.label {
			position: absolute;
			bottom: -5px;
		}
		.value-wrapper {
			display: flex;
		}
	}
`;

export const BasicGauge = ({ id, cypressId, width, height, percent, value, unit, label }) => {
	return (
		<GaugeStyle id={id} data-cy={cypressId} className='power-trends' width={width} height={height}>
			<div className='gauge-wrapper'>
				<CircularProgressbarWithChildren
					value={percent}
					circleRatio={0.75}
					strokeWidth={5}
					styles={buildStyles({
						trailColor: '#00AD5C',
						pathColor: '#00AD5C',
						strokeLinecap: 'butt',
						rotation: 0.625,
					})}
					className='custom-tooltip'
				>
					<div style={{ fontSize: 12, marginTop: -5 }}>
						<div className='value-wrapper'>
							<div>{value.toFixed(1)}</div>
							<div>{unit}</div>
						</div>
					</div>
					<div className='label body10'>{label}</div>
				</CircularProgressbarWithChildren>
			</div>
		</GaugeStyle>
	);
};
